import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { cartMobx } from 'restaurant'
import CartItem from '../CartItem'
import CashierController from '@ctrls/cashierController'
import './index.scss'

export interface ICartGivensProps {
  fullItemNFreeProducts?: IViewCartItem[] | IViewOrderDetail[];
}

const CartGivens: React.FC<ICartGivensProps> = (props) => {
  const { fullItemNFreeProducts } = props

  const filterProducts = useMemo(() => {
    return (fullItemNFreeProducts as IViewCartItem[])?.filter(
      (cartItem) => cartItem.cnt && !cartItem.disabled
    )
  }, [fullItemNFreeProducts])

  if (!fullItemNFreeProducts?.length) {
    return null
  }

  const handleSelectProduct = (cartItem) => {
    CashierController.editFullNFreeProduct(cartItem, cartItem.parentPk)
  }

  const handleChangePackCnt = (cartItem, cnt: number) => {
    cartMobx.setCarPackFkeys(`${cartItem.fkey}_fullNFree_${cartItem.pk}`, cnt)
  }

  return (
    <div
      className='cart-given-wrapper'
    >
      {
        filterProducts.map((cartItem, index) => (
          <div key={cartItem.pk}>
            <CartItem
              cartItem={cartItem}
              index={index}
              isGiven
              onSelect={() => handleSelectProduct(cartItem)}
              onChangePackCnt={(cnt) => handleChangePackCnt(cartItem, cnt)}
            />
          </div>
        ))
      }
    </div>
  )
}

export default observer(CartGivens)
